import { memo, useCallback } from 'react';
import { isAxiosError } from 'axios';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { useToast } from '@cbhq/cds-web/overlays/useToast';

import useHasExperiment from ':cloud/hooks/useHasExperiment';
import { useCreateCommerceCharge } from ':cloud/queries/BillingQueries/useCreateCommerceCharge';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';
import { openUrlInNewWindow } from ':cloud/utils/openUrlInNewWindow';

function BuyCreditsButton() {
  const toast = useToast();
  const isPayWithCryptoEnabled = useHasExperiment('jun_2024_pay_with_crypto', 'treatment');
  const { activeOrg } = useGetUser();
  const orgId = activeOrg?.organizationId;

  const createCommerceCharge = useCreateCommerceCharge(orgId);

  const handleBuyCredits = useCallback(() => {
    createCommerceCharge.mutate(undefined, {
      onSuccess: (data) => {
        openUrlInNewWindow(data.hostedUrl);
      },
      onError: (error) => {
        if (isAxiosError(error)) {
          toast.show('An error occurred while processing your request. Please try again.');
        }
      },
    });
  }, [createCommerceCharge, toast]);

  if (!isPayWithCryptoEnabled) {
    return null;
  }

  return <Button onPress={handleBuyCredits}>Buy credits with crypto</Button>;
}

export default memo(BuyCreditsButton);
